import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FaCheckCircle, FaGlobe, FaNetworkWired } from "react-icons/fa";
import Card from "../../../components/ui/Card";

const iconMap = [
  <FaCheckCircle size={28} />,
  <FaGlobe size={28} />,
  <FaNetworkWired size={28} />,
];

export default function NosotrosPillars() {
  const { t } = useTranslation();
  const items = t("nosotros.pillars.items", { returnObjects: true }) as any[];

  return (
    <Box component="section" sx={{ py: 12, bgcolor: "white" }}>
      <Container maxWidth="xl">
        <Box sx={{ textAlign: "center", mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              color: "#0A1128",
              mb: 2,
              fontSize: { xs: "2rem", md: "2.5rem" },
            }}
          >
            {t("nosotros.pillars.mainTitle")}
          </Typography>
          <Box
            sx={{
              width: 60,
              height: 4,
              bgcolor: "#68a8de",
              mx: "auto",
              borderRadius: 2,
            }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            flexWrap: { xs: "nowrap", md: "wrap" },
            gap: 4,
          }}
        >
          {Array.isArray(items) &&
            items.map((item, idx) => (
              <Box
                key={idx}
                sx={{
                  width: { xs: "100%", md: "calc(33.333% - 22px)" },
                }}
              >
                <Card icon={iconMap[idx]} item={item} idx={idx} isBlue />
              </Box>
            ))}
        </Box>
      </Container>
    </Box>
  );
}
